import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';

function getInitialView(color = '') {
  return {
    plotLineValue: '',
    plotLineDashStyle: 'solid',
    plotLineLabel: '',
    plotLineLabelPosition: 'top right',
    plotLineColor: color,
  };
}

function updateView(state, color) {
  const viewAdded = [...state.plotLines, getInitialView(color)];
  return { ...state, plotLines: viewAdded };
}

function deletePlotLine(stateTree, state, id, color) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));

  localStorage.setItem('saved', 'false');

  // TODO: review logic
  const removed = state.plotLines.reduce((accum, plotLine, idx) => {
    if (state.plotLines.length === 1 && idx === id) {
      accum = accum.concat([getInitialView(color)]);
    } else if (idx !== id) {
      accum.push(plotLine);
    }
    return accum;
  }, []);

  return {
    ...state,
    plotLines: removed,
    mustRender: activeDoc.mustRender,
  };
}

// helpers
function deepCopy(arr) {
  const copy = [];
  arr.forEach((obj) => {
    const tempObj = {};
    for (const [key, value] of Object.entries(obj)) {
      tempObj[key] = value;
    }
    copy.push(tempObj);
  });
  return copy;
}

function convertPlotlines(chart) {
  const defaultPlotline = {
    plotLineValue: '',
    plotLineDashStyle: 'solid',
    plotLineLabel: '',
    plotLineLabelPosition: 'top right',
    plotLineColor: '',
  };

  const plotLines = chart.data.plotLines ? deepCopy(chart.data.plotLines) : [defaultPlotline];

  return { plotLines };
}

function fetchPlotLineInfo(state, action) {
  if (!action.data) {
    return state;
  }
  if (action.data.status === 'success') {
    return convertPlotlines(action.data.body.chart);
  }
  return state;
}

function updateChart(stateTree, state, value, id, intervalType) {
  const { active } = stateTree.documents;
  let activeDoc = stateTree.documents.items[active];

  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));
  localStorage.setItem('saved', 'false');

  if (intervalType) {
    return {
      ...state,
      // TODO: review this logic
      plotLines: state.plotLines.map((plotLine, i) => {
        if (intervalType === 'plotLineColor' && id === 'all') {
          plotLine[intervalType] = value;
        } else if (id === i) {
          plotLine[intervalType] = value;
        }
        return plotLine;
      }),
      mustRender: activeDoc.mustRender,
    };
  }

  return state;
}

export { getInitialView, fetchPlotLineInfo, updateView, updateChart, deletePlotLine };
